import { useNavigate } from "react-router-dom";

export const useRedirect = () => {
  const navigate = useNavigate();

  const addNewVehicle = () => {
    navigate("/add_vehicle");
  };

  const redirectToEdit = (id) => {
    navigate(`/edit_vehicle/${id}`);
  };

  return { addNewVehicle,redirectToEdit };
};
